export default __webpack_public_path__ + "media/zurb/img/playground/lord-kelvin-banner-7f3b0051fae7068660d671a83fcdbb35.png";